module.exports = __webpack_public_path__ + "img/logo-xunta-off.1e1bff0a.png";